<!--考核科目弹窗选择-->
<template>
  <div>
    <el-input v-model="checkSubjectName"
              @focus="showDialog=!disabled"
              size="small"
              :clearable="true"
              @clear="clear"
              :disabled="disabled"
    >
      <i slot="suffix" class="el-input__icon el-icon-search" @click="showDialog=!disabled"></i>
    </el-input>

    <checkSubjectDialog v-if="showDialog" :param="param" :visiable.sync="showDialog" @commitSelect="commitSelect"/>
  </div>
</template>

<script>
import checkSubjectDialog from "@/views/dialogCommon/checkSubjectDialog2.vue";

export default {
  name: 'checkSubjectSearch',
  components: {checkSubjectDialog},
  props: {
    checkSubjectId: {
      required: true,
      type: [String, Number]
    },
    checkSubjectName: {
      required: true,
      type: [String]
    },
    param: {
      type: [Object]
    },
    disabled: {
      default: false
    },
  },
  data() {
    return {
      showDialog: false
    }
  },
  methods: {
    commitSelect(row) {
      console.log(row, 'commitSelect')
      this.checkSubjectName = row.name
      this.checkSubjectId = row.id
      this.$emit('update:checkSubjectName', this.checkSubjectName)
      this.$emit('update:checkSubjectId', this.checkSubjectId)
    },

    clear() {
      this.checkSubjectName = null
      this.checkSubjectId = null
      this.$emit('update:checkSubjectName', this.checkSubjectName)
      this.$emit('update:checkSubjectId', this.checkSubjectId)
    }
  }
}
</script>
